module.exports = __webpack_public_path__ + "static/media/karna_spearman.29fba2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_spearman.png
// module id = 398
// module chunks = 0